export const formName = 'augur-settings-parameter-tuning';

export const fieldParameterTuning = 'parameterTuning';

export const form = {
  form: formName,
};
